<template>
    <!--子表单新增、修改、查看-->
    <el-dialog :title="title+subformInfo.basicRename" width="80%" append-to-body :close-on-click-modal="false" :fullscreen="true"
               :visible.sync="visible" id="AddEditFormItem" v-if="visible">
        <AddEditFormItem :ref="`ref${subformInfo.basicCode}`" :refName="subformInfo.basicCode" :list="fieldList"
                         :form="form" :allForm="allForm" :method="method" :configId="configId" :basicDataId="basicDataId" :metadataBasicDataRuleVoList="metadataBasicDataRuleVoList" :metadataBasicDataShowRuleVo="metadataBasicDataShowRuleVo"></AddEditFormItem>
        <div slot="footer" class="text_center">
            <el-button size="small" type="primary" plain @click="visible = false">{{method == 'view' ? '关闭' : '取消'}}</el-button>
            <el-button size="small" type="primary" v-if="method != 'view'" :disabled="loading" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import AddEditFormItem from "./AddEditFormItem";

    export default {
        name: "AddEidtSubform",
        components: {AddEditFormItem},
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                fieldList: [],
                form: {
                    id: '',
                },
                row: {},
                allForm: {},
                subformInfo: {},  // 子表单信息
                configId: '',
                basicDataId: '',
                metadataBasicDataRuleVoList: [], // 数据规则集合
                metadataBasicDataShowRuleVo: [], // 隐显规则集合
            }
        },
        methods: {
            init(row, method, item, allForm, configId, basicDataId) {
                this.form = {id: ''}
                this.fieldList = []
                this.row = row
                this.method = method
                this.subformInfo = item
                this.allForm = allForm
                this.configId = configId || ''
                this.basicDataId = basicDataId || ''
                this.metadataBasicDataRuleVoList = []
                this.metadataBasicDataShowRuleVo = []
                this.visible = true
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                this.$nextTick(() => {
                    this.getFields()
                })
            },
            // 获取字段
            getFields() {
                this.loading = true
                this.$axios(this.api.metadata.selectTreeMetadataBasicDataById, {basicDataId: this.subformInfo.associationBasicDataId}, 'get').then(data => {
                    if (data.status) {
                        this.fieldList = data.data.children
                        this.metadataBasicDataShowRuleVo = data.data.metadataBasicDataShowRuleVo
                        this.recursion(this.fieldList, this.form)
                        this.$nextTick(() => {
                            this.form = this.recover(this.form, this.row);
                        })
                    }
                    this.loading = false
                })
            },
            // 递归
            recursion(list, form) {
                list.map(item => {
                    if(!item.basicCode) {
                        return
                    }
                    if(this.metadataBasicDataShowRuleVo && this.metadataBasicDataShowRuleVo.filter(v => v.basicCode == item.basicCode).length > 0) {
                        this.$set(item, 'showRuleFlag', false)
                    } else {
                        this.$set(item, 'showRuleFlag', true)
                    }
                    if (item.basicAssemblyId == 6 || item.basicAssemblyId == 7 || item.basicAssemblyId == 13 || item.basicAssemblyId == 14 || item.basicAssemblyId == 15 || item.basicAssemblyId == 16 || item.basicAssemblyId == 17 || item.basicAssemblyId == 19) {
                        this.$set(form, item.basicCode, [])
                    } else if (item.basicAssemblyId == 20) {
                        this.$set(form, item.basicCode, {})
                    } else {
                        if (item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleDefaultValue) {
                            this.$set(form, item.basicCode, item.metadataBasicDataRuleVo.ruleDefaultValue)
                        } else {
                            this.$set(form, item.basicCode, null)
                        }
                    }
                    if(item.metadataBasicDataRuleVo) {
                        this.$set(item.metadataBasicDataRuleVo, 'basicCode', item.basicCode)
                        this.metadataBasicDataRuleVoList.push(item.metadataBasicDataRuleVo)
                    }
                    if (item.children.length && item.basicAssemblyId == 20) {
                        this.recursion(item.children, this.form[item.basicCode])
                    }
                    if (item.children.length && item.basicAssemblyId == 18) {
                        this.recursion(item.children, this.form)
                    }
                })
            },
            doSubmit() {
                let flag = this.$refs[`ref${this.subformInfo.basicCode}`].doSubmit('19', {
                    form: this.form,
                    subformInfo: this.subformInfo,
                })
                if(flag) {
                    this.visible = false
                }
            },
        }
    }
</script>

<style scoped>

</style>
